import ddPropertyLocations from '../data/location/ddpropertyLocations.json';

type LocationType = 'province' | 'district' | 'area';

type LocationProps = {
  type_code: string;
  code: string;
  thai_name: string;
  english_name?: string;
};

const locationTypeMap: Record<string, LocationType> = {
  D: 'district',
  L: 'province',
  A: 'area',
};

export function getDDLocationDetails(code: string): {
  code?: string;
  type?: LocationType;
  thai_name?: string;
  english_name?: string;
} {
  const matchedLocation = (ddPropertyLocations as LocationProps[]).find(
    (item) => item.code === code,
  );

  if (!matchedLocation) return {};

  return {
    code: matchedLocation.code,
    type: locationTypeMap[matchedLocation.type_code],
    thai_name: matchedLocation.thai_name,
    english_name: matchedLocation.english_name,
  };
}
